import axiosTokenInstance from 'services/api/backoffice';
import {
  DETAIL_PURCHASE_ORDER_LIST_IPB,
  DETAIL_PURCHASE_ORDER_LIST_IPB_ERROR,
} from '_models/redux/types';

// Action function
export const purchaseOrderDetailListIpbAction = (transactions_id) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(`/api/ipb/orders/${transactions_id}`);

    const { data, status } = response || {};

    dispatch({
      type: DETAIL_PURCHASE_ORDER_LIST_IPB,
      response: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: DETAIL_PURCHASE_ORDER_LIST_IPB_ERROR,
      response: e || {},
    });
  }
};
